module.exports = __webpack_public_path__ + "500ead56df3108901b28583fbfded8d0.svg";